import { Component } from 'react';

export default class LogOut extends Component {
  componentDidMount = () => {
    this.props.logout();
    this.props.history.push('/');
    setTimeout(() => window.location.reload(), 500);
  }

  render = () => null
}
